import React from 'react'
import Layout from '../../../components/layouts/Layout'

function AdminHomePage() {
  return (
    <Layout headline='' title=''>AdminHomePage</Layout>
  )
}

export default AdminHomePage